import { render, staticRenderFns } from "./UsersEditComponent.vue?vue&type=template&id=3af68ea2"
import script from "./UsersEditComponent.vue?vue&type=script&lang=js"
export * from "./UsersEditComponent.vue?vue&type=script&lang=js"
import style0 from "./UsersEditComponent.vue?vue&type=style&index=0&id=3af68ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports